<script setup lang="ts">
// Confirmação de "Sair da conta" (Figma 23239:78544) — antes o botão
// deslogava direto, sem chance de cancelar. Mesmo shell dos outros modais
// do painel V2 (RewardRedeemModal.vue/AchievementModal.vue: bottom sheet no
// mobile, card centralizado no desktop), só sem o selo flutuante.
const isOpen = defineModel<boolean>({ required: true });

const emit = defineEmits<{ confirm: [] }>();

useBodyScrollLock(isOpen);

function close() {
  isOpen.value = false;
}

function confirmLogout() {
  close();
  emit('confirm');
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="isOpen"
      class="user-v2-logout-confirm-modal fixed inset-0 z-[100] flex items-end justify-center font-sans lg:items-center lg:p-[16px]"
      @dragstart.prevent
    >
      <!-- o clique fora cai NESTE backdrop (ele cobre o wrapper inteiro), não
           no wrapper — por isso o @click.self no pai nunca disparava e clicar
           fora não fechava. -->
      <div
        class="modal-backdrop absolute inset-0 bg-black/70"
        @click="close"
      />

      <div
        class="modal-card relative flex w-full flex-col gap-[24px] rounded-t-[20px] bg-v2-background px-[16px] pb-[40px] pt-[16px] text-left lg:max-w-[420px] lg:rounded-[20px] lg:pb-[24px]"
      >
        <UserV2ModalCloseButton @close="close" />

        <p class="pr-[40px] text-[18px] font-bold leading-[28px] text-white">
          Deseja mesmo sair da sua conta?
        </p>

        <p class="text-[14px] leading-[20px] text-v2-muted">
          Ao continuar conectado você receberá ofertas e benefícios apenas para
          usuários conectados.
        </p>

        <div class="flex gap-[13px]">
          <button
            class="flex h-[40px] flex-1 items-center justify-center rounded-[12px] bg-v2-default text-[14px] text-white"
            type="button"
            @click="confirmLogout"
          >
            Sair agora
          </button>
          <button
            class="flex h-[40px] flex-1 items-center justify-center rounded-[12px] bg-v2-primary text-[14px] text-v2-primary-foreground"
            type="button"
            @click="close"
          >
            Continuar conectado
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
// main.scss reseta `transition` no app inteiro — animação de entrada via
// @keyframes/animation (mesma estratégia do RewardRedeemModal.vue).
.modal-backdrop {
  animation: logout-confirm-fade 0.18s ease-out;
}

.modal-card {
  animation: logout-confirm-pop 0.2s ease-out;

  @media (max-width: 1023px) {
    animation-name: logout-confirm-slide-up;
  }
}

@keyframes logout-confirm-fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes logout-confirm-pop {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes logout-confirm-slide-up {
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
